/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { VehicleFit } from '@/api/types/browse-search-types';

type FitmentBadgeInput = {
  hasPreferredVehicle: boolean;
  isAppProduct: boolean;
  fitsVehicle: boolean;
  isVehicleSpecific: boolean;
  vehicleFit: VehicleFit | undefined;
};

/**
 * Mirrors the main PDP fitment badge rules (ProductAvailabilityInfoV2): the badge is shown for
 * app products that fit or are vehicle specific, or for any product flagged as MAY_NOT_FIT.
 * The fitment status is passed through untouched.
 */
export function getFitmentBadgeState({
  hasPreferredVehicle,
  isAppProduct,
  fitsVehicle,
  isVehicleSpecific,
  vehicleFit,
}: FitmentBadgeInput) {
  const hideLabel = !fitsVehicle && !isVehicleSpecific;
  const showFitmentBadge =
    hasPreferredVehicle && ((isAppProduct && !hideLabel) || vehicleFit === 'MAY_NOT_FIT');

  return { showFitmentBadge, fitsVehicle, vehicleFitment: vehicleFit };
}
